import api from "../../../../api/api";

export const getFollowupList = (page: number, params: any = {}) => {
  return api.get("/crm/v1/sales-followups/", {
    params: {
      page,
      ...params, // contains vertical_id
    },
  });
};

export const convertToInquiry = (id: number, vertical: number) => {
  return api.post(`/crm/v1/followup/${id}/convert-enquiry/`, {
    vertical,
  });
};